// import '@/scss/common.scss';
// import '@/scss/topbar.scss';
// import '@/scss/assessment.scss';

import {
  VConsole,
  axios,
  Stream,
  Bridge,
  toast,
  isAPP,
  isAliMp,
  isMeiTuanMp,
  APIS,
  dom,
  jumpMethods,
  Stat,
  getRequireParams,
  appTrackPageView,
  appTrackEvent,
  $trackPageView,
  $trackEvent,
} from '@/entry/templateCommon';
import '@/scss/evaluate-list.scss';
import '@/scss/detail.scss';
import {GetQueryString, objToUrlParams, loadScript, urlCategoryMap} from '@/lib/util';
import {getScrollTop, setScrollTop} from '@/lib/scrollVariate';
import buyFuns from '@/util/buyScaleFun';
import {getPlatform} from '@/util/tool';
import loading from '@/lib/loading';
import channelMap from '@/util/channelIdMap.config';
import {getVipinfo} from '@/entry/getUserKey'

// import VConsole from 'vconsole'
new VConsole();

loadScript('//static.xinli001.com/frontend-lib/monitor.js').then(() => {
  window.monitor.rootData.from = 'cp-m';
})
const detailUrl = location.href;


async function detailPage() {
  /* ---业务代码开始--- */
  const slice = Array.prototype.slice;
  const $likeBtn = document.getElementById('like-btn');
  const $likeClassList = $likeBtn.querySelector('i').classList;
  const $serviceTipsWrap = document.querySelector('.service-tips-wrap');
  const log = console.log.bind(console)
  const e = function(sel) {
    return document.querySelector(sel)
  }
  // 页面要用到的参数
  let selectedScalePoolId;
  let selectedTredeType;
  let hasChildScale = false;
  let scalePoolId;
  let uuid;
  let cpVipData;
  //添加域名cp-wx
  let isCpWx = location.host == `cp-wx${APIS.env}.xinli001.cc`

  let newLingxi = location.host == `m-lingxi${APIS.env}.xinli001.com`
  let newCpapiHost = location.host == `m-cpapi${APIS.env}.xinli001.com`

  // 能匹配cpapi/m .xinli001.com 的 线上、box、qc环境的正则表达式
  if (/(cpapi|m)(\-(qc\d{1}|box\d{1}))?.xinli001.com/.test(location.origin) || isCpWx || newLingxi || newCpapiHost) {
    let urlArray = location.pathname.split('/');
    scalePoolId = urlArray[urlArray.length - 1]
  }

  console.log(`测评ID是`, scalePoolId)
  function isActivityDoubleEleven() {
    let activityScalePoolIds = [758, 761, 759, 760, 762, 767, 763, 765, 764, 766]
    let r = activityScalePoolIds.includes(Number(scalePoolId))
    console.log('--- 是否是双十一活动id ----', r)
    return r
  }
  let isActivity20201111 = isActivityDoubleEleven()

  let scalePrice = document.querySelector('.art-price').innerText.split(' ')[0].replace('￥', '').replace('.', '') * 1;
  // URL附带参数
  let requiredParams = await getRequireParams();
  let myTracker = window.myTracker = new Stat({
    globalParams: {
      '渠道ID': requiredParams.channelId * 1,
      '渠道': channelMap.map[requiredParams.channelId]
    }
  });
  let scaleName = window.scaleName = document.querySelector('.art-title').innerText;
  let hideWXH5pay = function () {
    slice.call(document.getElementById('product-pay-method').children).forEach(node => {
      if (node.getAttribute('data-key') == 'WX_H5_PAY') {
        node.style.display = 'none';
      }
    });
  };

  // 隐藏分享按钮，修改头部标题
  function hideShareBtn () {
    if (platform.isYixinliApp) {
      let myBridge = new Bridge()
      myBridge.call('topFuncBtnConfig', {
          btnList:[]
      })
      myBridge.call('setTitle', {title: '全年会员'})
    }
  }

  // 是否是抑郁单品
  const isDepression = +scalePoolId === 696
  let depressionPrice
  let packageId
  if (isDepression) {
    e('#app').classList.remove('app-page--has-topbar')

    if (e('.topbar'))e('.topbar').style.display = 'none'

    e('.art-handler').style.visibility = 'hidden'

    const $detailArticle = e('.detail-article')
    $detailArticle.classList.add('is-depression')

    initDepression()
  }

  // 打包 vip 购买
  let isBuyCpVip = false
  // 打包 倾诉 购买
  let isPackQingSu = false

  async function initDepression () {
    const handlePayment = (item) => {
      depressionPrice = item.price/100
      if (e('.totalCost span')) {
        e('.totalCost span').innerText = `￥${item.price/100}`
      }
      packageId = item.packageId
      e('.buy-btn').click()
    }

    const pricePackages = await getPricePackages()
    const buyList = await getBuyList()
    const vipInfo = await fetchVipInfo()
    const isFree = vipInfo ? vipInfo.status === 1 && vipInfo.vipIdentity > 2 : false
    if (pricePackages.length) {
      const isConsult = pricePackages[0].packageId === 20014
      let bgImg = 'https://imgco.xinli001.com/op/lx_admin/20211201/7e1660f1a40746a9b7930d93b9cfd9e9.jpg'
      if (isConsult) bgImg = 'https://imgco.xinli001.com/ceping/resources/images/trinyMCE/e984facd5a664fd1b008dae0f0d36170.jpg'
      const innerHTML = `
        <div class="depression__loop" style="animation-duration: ${5 + buyList.length*3}s">
          ${
            buyList.map(item => {
              return `
                <div class="depression__loop-item">
                    <img class="depression__item-avatar" src="${item.avatar}" alt="">
                    <span>${item.name} ${item.time}购买</span>
                </div>
              `
            }).join()
          }
        </div>
        <img class="depression__bg" src="${bgImg}" alt="">
        <div class="depression__footer">
            <div class="depression__price">
                <div class="depression__price-d-1">
                    <span class="depression__price-title"></span>` +
                    (isFree ? '' : `<span class="depression__price-num">￥${pricePackages[0].price / 100}</span>`) +
                `</div>
                <div class="depression__price-d-2">
                    <span class="depression__price-name ${isConsult ? 'is-consult' : ''}"></span>
                    <span class="depression__price-num">￥${pricePackages[1].price / 100}</span>
                </div>
            </div>
        </div>
      `
      e('#app').insertAdjacentHTML('beforeend', innerHTML)
      e('.depression__price-d-1').addEventListener('click', () => {
        handlePayment(pricePackages[0])
      })
      e('.depression__price-d-2').addEventListener('click', () => {
        handlePayment(pricePackages[1])
      })
    }
  }
  // 获取抑郁单品价格列表
  function getPricePackages () {
    return new Promise(resolve => {
      axios.get(`${APIS.lingxiHost}depressed/depressedPackages`, {
        params: {
          channelId: Number(requiredParams.channelId),
          userKey: requiredParams.userKey
        }
      }).then(res => {
        if (res.data.code == '1') {
          const data  = res.data.data
          resolve(data.packages)
        }
      })
    })
  }

  // 获取最新购买用户列表
  function getBuyList () {
    return new Promise(resolve => {
      axios.get(`${APIS.lingxiHost}depressed/getDepressedUserList`, {
        params: {
          channelId: Number(requiredParams.channelId),
        }
      }).then(res => {
        if (res.data.code == '1') {
          const data  = res.data.data
          resolve(res.data.data || [])
        }
      })
    })
  }

  function fetchVipInfo() {
    return getVipinfo({
      channelId: requiredParams.channelId,
      userKey: requiredParams.userKey
    }).then(res => {
      return res.data.data
    })
  }

  myTracker.send({
    name: `v5100_测评_访问测评详情页`,
    properties: {
      '测评名称': scaleName
    }
  });

  // 测评-app&外部渠道-测评详情页访问 神策埋点（放开只在 app 埋点）
  $trackPageView('app_cepinghome_cepingdetail_view', {
    test_id: scalePoolId,
    test_name: scaleName,
    source_page: GetQueryString("_source_page_"),
    test_channel_id: requiredParams.channelId,
    test_channel_name: channelMap.map[requiredParams.channelId],
    tracing_mark:  GetQueryString("sourceName"),
  })

  window.sharePageName = '测评详情页';
  window.sharePagOption = {
    '测评名称': scaleName
  };
  // 平台适配
  let platform = getPlatform();
  // 美团用微信 sdk
  if (platform.isWechat && !isMeiTuanMp) {
    // 地址模板
    // https://ce.xinli001.com/cp/index.html?init=16#/detail/153?channelId=1
    loading('即将为您跳转到微信站点');
    let wxCpUrl;
    if (requiredParams.channelId * 1 === 514) {
      wxCpUrl = `${location.protocol}//ce${APIS.env}.xinli001.com/cp/index.html#/detail/${scalePoolId}?channelId=1037`;
    } else if (requiredParams.channelId * 1 === 324) {
      wxCpUrl = `${location.protocol}//ce${APIS.env}.xinli001.com/cp/index.html#/detail/${scalePoolId}?channelId=1115`;
    } else {
      wxCpUrl = `${location.protocol}//ce${APIS.env}.xinli001.com/cp/index.html#/detail/${scalePoolId}?channelId=513`;
    }
    jumpMethods.openUrl(wxCpUrl);
    return;
  } else if (platform.isPc) {
    // 针对PC隐藏了微信H5支付的选项
    hideWXH5pay();
  }

  if(+requiredParams.channelId === 1353) {
    hideWXH5pay();
  }

  document.querySelector('#app').style.display = 'block';

  if (scaleName.length >= 13) {
    document.querySelector('.art-title').classList.add('twoLine');
  }
  let detailObject = {
    initRecomend() {
      let listEle = document.getElementById('recomemdList');
      if (listEle) {
        listEle.addEventListener('click', (e) => {

          if (e.target.className == 'assessment-list__item-tag') {
            let outerText = e.target.outerText.split('-')[0]
            jumpMethods.goToSortPage(Object.assign({}, {
              category: urlCategoryMap(outerText)
            }));
            return
          }

          let liEle = dom.closest(e.target, 'li');
          if (liEle) {
            // myTracker.detailRecomend(scaleName);
            myTracker.send({
              name: `v5100_测评_点击测评详情页-相关推荐`,
              properties: {
                '测评名称': scaleName
              }
            });
            jumpMethods.goToProTestPage(Object.assign(requiredParams, {
              scaleId: liEle.getAttribute('data-id')
            }));
          }
        })
      }
    },
    getRecomend({userKey}) {
      /**
             * page    false    int    返回结果的页码，默认为1。
             * pageSize    false    int    单页返回的记录条数，默认是4条
             * userKey    true    String    用户 userKey
             * channelId    true    int    表示所属公众号渠道id
             * id    true    int    当前测试id
             * from 大家都在测的位置 详情页:detail 结果页:result
             */
      const stringFactory = function (data) {
        return `<li class="assessment-list__item" data-id="${data.scalePoolId}">
                        <div class="cf">
                            <div class="fl assessment-list__item__left">
                                <h3 class="assessment-list__item-title color-main text-limit fs-16">${data.shortDescribe}</h3>
                                <div class="assessment-list__item-desc color-light text-limit fs-12">${data.name}</div>
                                <div class="assessment-list__item-tag fs-12">一级标签 二级标签</div>
                            </div>
                            <div class="fr">
                                <img src="${data.listPicture}" alt="" class="assessment-list__item-img"></div>
                            </div>
                            <div class="assessment-list__item-footer cf fs-12">
                                <div class="color-red fl">${data.discountPrice}</div>
                                <div class="color-light fr">${data.count}人已测</div>
                            </div>
                        </li>`;
      };

      Stream.ajax('/api/getDetailRelevantScales', Object.assign(requiredParams, {
        page: 1,
        pageSize: 10,
        userKey,
        scalePoolId: scalePoolId,
        from: 'detail'
      })).addListener({
        next(json) {
          const {code, msg, data} = json;
          if (+code === 1) {
            if (data.scales.length > 0) {
              let detailEle = document.querySelector('.detail-article');
              let listEle = document.getElementById('recomemdList');
              if (listEle) {
                listEle.innerHTML = data.scales.map(stringFactory).join('');
              } else {
                listEle = document.createElement('div');
                listEle.innerHTML = `<section class="hr art-content box-padding">
                                                        <h2 class="common-section-title fs-16">热门心理测试推荐</h2>
                                                        <ul id="recomemdList">${data.scales.map(stringFactory).join('')}</ul>
                                                    </section>`
                detailEle.appendChild(listEle);
              }
              listEle.addEventListener('click', (e) => {
                let liEle = dom.closest(e.target, 'li');
                if (liEle) {
                  jumpMethods.goToProTestPage(Object.assign(requiredParams, {
                    scaleId: liEle.getAttribute('data-id')
                  }));
                }
              })
            } else {
              console.log('---推荐测评为空---');
            }
          }
        }
      })
    },
    getReviewbox() {
     var loopData = document.getElementById("testDepressionLoop");
     if (loopData) {
       loopData.style = `animation-duration: ${5 + loopData.children.length*3.5}s;display: inline-flex;`
     }
     // loopData.style = `animation-duration: ${5 + loopData.children.length*3.5}s;display: inline-flex;`
    },
    initRings() {
      // 环形效果
      const rings = slice.call(document.querySelectorAll('.evaluate-ring'), 0);
      rings.forEach(function (node) {
        var value = +node.getAttribute('data-value');
        var classList = node.classList;

        if (value >= 2.5) {
          classList.add('evaluate-ring--b');
          classList.remove('evaluate-ring--a');

          node.getElementsByTagName('i')[0].style.transform = `rotate(${-180 + 180 * (value - 2.5) / 2.5}deg)`;
        } else if (value > 0 && value < 5) {
          classList.add('evaluate-ring--a');
          classList.remove('evaluate-ring--b');

          node.getElementsByTagName('i')[1].style.transform = `rotate(${-180 + 180 * (value) / 2.5}deg)`;
        } else {
          classList.remove('evaluate-ring--a');
          classList.remove('evaluate-ring--b');
        }
      });
    },
    addToFavorInit() {
      // 想测
      /**
             * channelId    true    int    渠道id。
             * scalePoolId    true    int    量表池id。
             * status    true    boolean    想测 传true，取消想测 传 false。
             * userKey    true    string    用户 userKey，由测评详情页获取的 数据传过来。
             * id    false    int    想测id，由测评详情页获取的想测数据 传过来。有id代表更新，0代表创建。
             */
      var {userKey, userId, channelId} = requiredParams;
      console.log(`https://account${APIS.env}.xinli001.com/login?next=${encodeURIComponent(detailUrl)}`);
      var redirectUrl = '';
      if (platform.isPc) {
        redirectUrl = `https://account${APIS.env}.xinli001.com/login?next=${encodeURIComponent(detailUrl)}`;
      }
      Stream.fromEvent($likeBtn, 'click')
        .do(() => {
          if (!userKey && !userId) {
            if (platform.isPc) {
              location.href = `https://account${APIS.env}.xinli001.com/login?next=${encodeURIComponent(detailUrl)}`;
              console.log(location.href);
            } else if (isAliMp) {
              window.$uniAppNavto.login()
            }
          }
        })
        .map(() => $likeClassList.contains('icon-like-active'))
        .flattenMap(like => Stream.ajax('/api/favor/favorScale', Object.assign(requiredParams, {
          scalePoolId,
          status: !like,
          userKey,
          id: $likeBtn.getAttribute('data-favor'),
          redirectUrl: redirectUrl, // 添加此参数，后端返回前端302的时候，就会不使用后端返回的地址，使用这个参数指定的地址
          testType: 0, // 专业测评
        }), false)
          .pardonError(err => {
            console.error(err);
          }))
        .flattenMap(like => Stream.of(like))
        .addListener({
          next(res) {
            const {code, data} = res;
            if (+code === 1) {
              if (data.status === false) {
                $likeBtn.classList.remove('like-active')
                $likeClassList.remove('icon-like-active');
                $likeClassList.add('icon-like');
              } else {
                $likeBtn.setAttribute('data-favor', res.data.id);
                $likeBtn.classList.add('like-active');
                $likeClassList.remove('icon-like');
                $likeClassList.add('icon-like-active');
                toast('收藏成功！可在“测试管理--想测”查看该内容');
              }
              // myTracker.detailCollect(scaleName);
              myTracker.send({
                name: `v5100_测评_点击“想测”`,
                properties: {
                  '测评名称': scaleName
                }
              });
            }
            // console.log(like);
            // $likeClassList.add(!like ? 'icon-like-active' : 'icon-like');
            // $likeClassList.remove(like ? 'icon-like-active' : 'icon-like');
          }
        });
      // $likeBtn.addEventListener('click', () => {
      //     let curLike = $likeClassList.contains('icon-like-active');
      //     console.log(channelId);
      //     axios.get('/api/favor/favorScale', {params: {channelId, scalePoolId, status: !curLike, userKey}}).then(res => {
      //         console.log(res.data);
      //         let {code, msg, data} = res.data;
      //         if (+code === 1) {
      //             if (data.status === 'false') {
      //                 $likeClassList.remove('icon-like-active');
      //             } else {
      //                 $likeClassList.add('icon-like-active');
      //             }
      //         } else if (+code === 1005) {
      //             toast('未登录');
      //         } else {
      //             toast(msg);
      //         }
      //     });
      // });
    },

    // 客服按钮
    serviceInit() {
      Stream.merge(
        Stream.fromEvent(document.getElementById('service-btn'), 'click').map(() => !$serviceTipsWrap.style.display),
        Stream.fromEvent($serviceTipsWrap, 'click').mapTo(false)
      )
        .addListener({
          next(doShow) {
            var st = getScrollTop();
            $serviceTipsWrap.style.display = doShow ? 'block' : '';
            doShow && ($serviceTipsWrap.style.height = document.querySelector('.art-handler').getBoundingClientRect().top + 'px');

            document.documentElement.classList[doShow ? 'add' : 'remove']('ov-h');
            setScrollTop(st);

            // myTracker.detailCustomService(scaleName);
            myTracker.send({
              name: `v5100_测评_点击“客服按钮”`,
              properties: {
                '测评名称': scaleName
              }
            });
          }
        });
    },
    getCategoryTap(){
      const $thiscategory = document.querySelector('.test-detail__category')
      const thiscategoryText = document.querySelector('.test-detail__category').firstElementChild.innerText.slice(0,2)
      var categoryUrl = `https://m${APIS.env}.xinli001.com/ceshi/${urlCategoryMap(thiscategoryText)}`
      $thiscategory.addEventListener('click', function (ev) {
          if (platform.isYixinliApp) {
              let url = new URL(categoryUrl);
              let myBridge = new Bridge();
              if (url.hash.indexOf('?') > -1) {
                  let hashQuery = stringToObj(url.hash.split('?')[1]);
                  hashQuery.channelId = undefined;
                  url.hash = url.hash.split('?')[0] + '?' + objToUrlParams(hashQuery);
                  categoryUrl = url.href + '&isCp=1'
              } else {
                  categoryUrl = categoryUrl + '?isCp=1'
              }
              myBridge.call('openWebView', {url: `${categoryUrl}`, isCurrentPageOpen: 0});
          } else {
              let urlObj = new URL(categoryUrl);
              window.location.href = urlObj.href;
          }
      });
    }
  }

  detailObject.initRecomend()
  detailObject.initRings()
  detailObject.addToFavorInit()
  // detailObject.serviceInit()
  detailObject.getReviewbox()
  detailObject.getCategoryTap()
  if (document.querySelector('[data-more-evaluation]')) {
    document.querySelector('[data-more-evaluation]').addEventListener('click', () => {
      // https://ce-box3.xinli001.com/cp-m/index.html#/assessment/pro/725/comment?userId=1050459&openId=yxl-1001157877&unionId=omUXEuDg1AyPaLduGCTa8QLz66lY&userKey=14004262983657472027&channelId=513&appCode=1
      // myTracker.detailMoreComment(scaleName);
      myTracker.send({
        name: `v5100_测评_查看全部评价-测评详情页`,
        properties: {
          '测评名称': scaleName
        }
      });
      let url = `${location.protocol}//ce${APIS.env}.xinli001.com/cp-m/index.html#/assessment/pro/${scalePoolId}/comment?${objToUrlParams(Object.assign({}, requiredParams, {isCp: 1}))}`;
      jumpMethods.openUrl(url)
    })
  }
  if (GetQueryString('payDone') && !isAPP) {
    // 有payDone意味着是APP支付完然后浏览器内打开，会唤醒壹心理APP
    location.href = 'yixinli://';
  }

  // 关闭购买
  document.querySelector('.pay-panel .icon-close-btn') && document.querySelector('.pay-panel .icon-close-btn').addEventListener('click', function (e) {
    var $dialog = dom.closest(e.target, '.pay-panel-wrap');

    $dialog.classList.add('pay-panel-wrap--close');
    setTimeout(function () {
      $dialog.style.display = 'none';
    }, 300);
  });

  let goonBuy = 0;
  let buyFlow$;
  initBuyFlow();

  // 购买逻辑
  function initBuyFlow() {
    console.log('=== initBuyFlow ===')
    Stream.fromEvent(document.querySelector('.buy-btn'), 'click')
      .filter(res => {
        let {userKey, userId, channelId} = requiredParams;
        let disable = [...document.querySelector('.buy-btn').classList].includes('disable');
        if (disable) {
          toast('此测评已下架');
        }
        // 测评详情页的登录判断加多一个userId，当userId和userKey均为空时判断为未登录，前端跳去登录页面
        if (!userKey && !userId) {
          toast('请先登录')
          let backUrl = `${encodeURIComponent(detailUrl)}`;

          if (platform.isYixinliApp) {
            // 壹心理APP 走登录协议
            location.href = 'yixinli://open_user_login';
          } else if (platform.isPc) {
            // PC站，使用PC登录页
            location.href = `https://account${APIS.env}.xinli001.com/login?next=${encodeURIComponent(detailUrl)}`;
          } else {
            // 其他情况，如M站、口袋心理，使用旧版登录页，并且登录完会自动触发autoBuy，
            // referer 表示登录页不点击APP标题栏返回，点击了页面上的返回，去的地方
            let url = `https://m${APIS.env}.xinli001.com/account/login-for-ceping?callbackUrl=${encodeURIComponent(`https://m${APIS.env}.xinli001.com/ceping/${scalePoolId}?channelId=${channelId}&autoBuy=1&userKey=`)}&referer=${backUrl}`;
            if (isAliMp || isMeiTuanMp) {
              window.$uniAppNavto.login()
            } else {
              location.href = url
            }
          }
          return false;
        }
        // return true
        return !disable || (!userKey && userId);
      })
      .do(function () {
        // myTracker.detailBuynow(scaleName)
        myTracker.send({
          name: `v5100_测评_点击“立即购买”`,
          properties: {
            '测评名称': scaleName
          }
        });
        // 测评-app&外部渠道-测评详情页-点击立即测试 神策埋点
        $trackEvent('app_cepingdetail_clickstarttest', {
          test_id: scalePoolId,
          test_name: scaleName,
          test_channel_id: requiredParams.channelId,
          test_channel_name: channelMap.map[requiredParams.channelId],
        })

        let buyBtn = document.querySelector('.buy-btn')
        let vip = buyBtn.dataset.vip
        if (vip == 'halfPrice') {
          console.log('5折埋点')
          myTracker.send({
            name: '测评-页面交互',
            properties: {
              '点击“会员5折测按钮”': scaleName
            }
          });
          myTracker.send({
            name: '会员升级2020--页面访问',
            properties: {
              '页面名称': '会员2020-测评详情页-会员5折测按钮',
              '渠道ID': requiredParams.channelId,
              '来源域名': location.hostname
            }
          })
        } else if (vip == 'isVip') {
          console.log('会员免费测埋点')
          myTracker.send({
            name: '测评-页面交互',
            properties: {
              '点击“会员免费测”': scaleName
            }
          });
        }

        // 显示购买参数弹窗
        if (isMeiTuanMp && !hasChildScale) {
          // 美团小程序没有子测评不展示弹窗
          // selectSpec$ = Stream.combine(spec$.startWith(''), payMethod$.startWith(document.querySelector('#product-pay-method li').getAttribute('data-key')))
        }
        else
        if (scalePrice !== 0
          || (scalePrice === 0 && cpVipData.vipStatus == 1 && cpVipData.vipIdentity < 9)
          || hasChildScale) {
          var $dialog = document.querySelector('.pay-panel-wrap');
          $dialog.style.display = '';
          // $dialog.clientHeight;
          $dialog.classList.remove('pay-panel-wrap--close');
          // 页面添加优惠券(抑郁单品、美团小程序不要)
          if (!isDepression && !isMeiTuanMp) {
            insertCoupon()
          }
          if (cpVipData) {
            // 测评-支付弹窗展示, 第 2 次以后打开
            appTrackEvent('weizhan_cepingpurchasepop_view', {
              test_id: scalePoolId,
              test_name: scaleName,
              test_channel_id: channelId,
              test_channel_name: '壹心理APP',
              vip_status: cpVipData ? cpVipData.vipStatus == 1 : false
            })
          }
          // 重置参数选择
          if (resetSpecInEveryTime) {
            payMethod$.next('');
            spec$.next('');
          }
        }

        // 初始化支付宝小程序购买按钮
        if (isAliMp) {
          // 添加默认支付类型
          let payDom = document.querySelector('#product-pay-method .active')
          if (!payDom) {
            payDom = document.querySelector('#product-pay-method li')
            payDom.classList.add('active')
            // console.log('=== payDom ===', payDom)
            selectSpec$ = Stream.combine(spec$.startWith(''), payMethod$.startWith(document.querySelector('#product-pay-method li').getAttribute('data-key')))
            // 模拟点击，更新支付按钮状态
            payDom.click()
          }
        }
        // 美团弹窗只展示支付按钮 和 子测评版本
        if (isMeiTuanMp) {
          let payMethodTitle = e('.product-pay-method-title')
          if (payMethodTitle) {
            payMethodTitle.style.display = 'none'
          }
          let payMethodsDom = document.querySelectorAll('#product-pay-method li')
          if (payMethodsDom.length) {
            payMethodsDom.forEach(dom => {
              // console.log('=== payMethodsDom === dom: ', dom)
              dom.style.display = 'none'
            })
            // 添加默认支付类型，后面手动改成美团支付类型
            payMethodsDom[0].classList.add('active')
            selectSpec$ = Stream.combine(spec$.startWith(''), payMethod$.startWith(document.querySelector('#product-pay-method li').getAttribute('data-key')))
          }
        }
      })

    // 收集购买参数
      .flattenMap(() => {
        if (isMeiTuanMp && !hasChildScale) {
          // 美团小程序没有子测评不展示弹窗
          return Stream.combine(spec$.startWith(''), payMethod$.startWith(document.querySelector('#product-pay-method li').getAttribute('data-key')));
        }
        else
        if (scalePrice !== 0
          || (scalePrice === 0 && cpVipData.vipStatus == 1 && cpVipData.vipIdentity < 9)
          || hasChildScale) {
          // 6.0 以下的会员，价格虽然为0，但是要在弹窗中勾选
          return (resetSpecInEveryTime ? Stream.combine(spec$.startWith(''), payMethod$.startWith('')) : selectSpec$)
            .do(res => {
              let action = res.filter(str => str).length === (hasChildScale ? 2 : 1) ? 'remove' : 'add'
              if (e('.selectProtocol .select-icon') && !e('.selectProtocol .select-icon').classList.contains('check')) {
                // 没选测评协议
                action = 'add'
              }
              document.getElementById('pay-btn').classList[action]('cp-btn--disabled');
            })
            .debounce(() => pay$);
        } else {
          return Stream.combine(spec$.startWith(''), payMethod$.startWith(document.querySelector('#product-pay-method li').getAttribute('data-key')));
        }
      })
      .flattenMap(params => pay$.startWith('').mapTo(params).endWhen(Stream.merge(spec$, payMethod$)))

    // 检查参数有效性
      .do(res => {
        console.log('检查参数有效性 res:', res);
        // 测评-app&外部渠道-测评支付弹窗页-确认支付 神策埋点
        if ((isMeiTuanMp && isPackQingSu && +scalePrice !== 0)
          || +scalePrice === 0) {
          // 美团打包倾诉流程，不埋点
          // 0 元不会弹窗，也不埋点
        } else {
          $trackEvent('app_cepingpurchasepop_clickbuy', {
            test_id: scalePoolId,
            test_name: scaleName,
            test_channel_id: requiredParams.channelId,
            test_channel_name: channelMap.map[requiredParams.channelId],
          })
        }

        let selectProtocol = e('.selectProtocol .select-icon') ? e('.selectProtocol .select-icon').classList.contains('check') : true
        if (hasChildScale && !res[0]) toast('请选择版本', 'spec');
        else if (!res[1]) toast('请选择付款方式', 'spec');
        else if (!selectProtocol) toast('请阅读并同意《测评服务条款》', 'spec');
      })
      .filter(res => {
        let childScaleBool = res.filter(str => str).length === (hasChildScale ? 2 : 1)
        let protocolBool = e('.selectProtocol .select-icon') ? e('.selectProtocol .select-icon').classList.contains('check') : true
        let r = childScaleBool && protocolBool
        return r
      })
      .debug()

    // 调起支付
      .flattenMap(res => {
        selectedScalePoolId = res[0] || scalePoolId;
        selectedTredeType = res[1];
        if (platform.isYixinliApp) {
          if (selectedTredeType == "ALI_PAY_WAP") {
            selectedTredeType = 'ALI_PAY_APP'
          } else if (selectedTredeType == "WX_H5_PAY") {
            selectedTredeType = 'WX_PAY_APP'
          }
        } else if (+requiredParams.channelId == 4925 || navigator.userAgent.indexOf('AlipayClient') > -1) {
          // 支付宝小程序
          selectedTredeType = 'ALI_PAY_MINIAPP'
        } else if (isMeiTuanMp) {
          // 美团小程序
          selectedTredeType = 'MEITUAN_MINI_APP'
        }
        let buyBtn = document.querySelector('.buy-btn')
        let vip = buyBtn.dataset.vip
        let vipTest = vip == 'isVip' || vip == 'halfPrice' ? 1 : 0
        let params = Object.assign(requiredParams, {
          tradeType: selectedTredeType,
          scalePoolId: selectedScalePoolId,
          pagescaleId: scalePoolId,
          goonBuy: 0,
          uuid: uuid,
          vipTest: vipTest,
          sensorDistinctId: window.sensors ? window.sensors.quick('getAnonymousID') : "",
        })

        if (isBuyCpVip) {
          params = {
            channelId: Number(requiredParams.channelId),
            vipComboCpId: selectedScalePoolId,
            'order.tradeType': selectedTredeType,
            'order.userKey': requiredParams.userKey || '35575794488809881620',
            'order.openid': requiredParams.openId,
            // 'order.disCode': disCode,
            'order.sourceName': 'cporder_buycpvip',
          }
        }
        // 抑郁单品
        else if (isDepression) {
          params = {
            channelId: Number(requiredParams.channelId),
            scalePoolId: scalePoolId,
            packageId: packageId,
            tradeType: selectedTredeType,
            source: 0,
            userKey: requiredParams.userKey
          }
        } else if (isMeiTuanMp && isPackQingSu && +scalePrice !== 0) {
          // 打包倾诉需要用户付费时才打包
          params = {
            channelId: Number(requiredParams.channelId),
            scalePoolId: selectedScalePoolId,
            // scalePoolId: 644,
            userKey: requiredParams.userKey,
            // userKey: "35575794488809881620",
            tradeType: selectedTredeType,
          }
        }

        if (!isBuyCpVip) {
          // 购买测评添加跟踪标识
          if (GetQueryString("sourceName")) {
            params.sourceName = GetQueryString("sourceName")
          }
        }

        // 测评-支付弹窗-点击立即支付 神策埋点
        appTrackEvent('weizhan_cepingpurchasepop_clickbuy', {
          test_id: scalePoolId,
          test_name: scaleName,
          test_channel_id: channelId,
          test_channel_name: '壹心理APP',
          vip_status: cpVipData ? cpVipData.vipStatus == 1 : false,
          business_type: isBuyCpVip ? "测评会员" : "测评"
        })
        // myTracker.detailViewPay(scaleName);
        myTracker.send({
          name: `v5100_测评_访问支付页`,
          properties: {
            '测评名称': scaleName
          }
        });
        console.log('购买的参数', params);

        let buyFunction = buyFuns.buyRequest
        if (isBuyCpVip) {
          buyFunction = buyFuns.buyCpVip
        } else if (isDepression) {
          buyFunction = buyFuns.buyDepression
        } else if (isMeiTuanMp && isPackQingSu && +scalePrice !== 0) {
          buyFunction = buyFuns.buyPackQingSu
        }
        // return
        return buyFunction(params, requiredParams.userKey);
      })

      .addListener({
        next(res) {
          console.log('next to do what res', res);
          console.log(requiredParams);
          let params = Object.assign(requiredParams, {
            tradeType: selectedTredeType,
            scalePoolId: selectedScalePoolId,
            pagescaleId: scalePoolId,
            goonBuy: 0
          })
          let payType = ''
          if (isBuyCpVip) {
            params = {
              channelId: Number(requiredParams.channelId),
              userKey: requiredParams.userKey,
              'order.openid': requiredParams.openId,
              'order.sourceName': GetQueryString("sourceName"),
              tradeType: selectedTredeType,
              scalePoolId: selectedScalePoolId,
            }
            payType = 'cpVip'
          } else if (isDepression) {
            params = {
              channelId: Number(requiredParams.channelId),
              scalePoolId: scalePoolId,
              packageId: packageId,
              tradeType: selectedTredeType,
              source: 0,
              userKey: requiredParams.userKey
            }
            payType = 'depression'
          }

          buyFuns.afterBuy(res, params, requiredParams.userKey, payType).then(res => {
            console.log('buyFuns.afterBuy 之后的 res', res)
            // myTracker.detailPaySuccess(scaleName);
            myTracker.send({
              name: `v5100_测评_支付成功`,
              properties: {
                '测评名称': scaleName
              }
            });
            if (isDepression) {
              location.href = `${APIS.lingxiHost}depressed/pay/done/${res.id || res.orderId}`
            }
          });
        },
        error: err => console.error(err)
      });
  }

  // 购买参数的选择与支付按钮
  var payMethod$ = Stream.Subject();
  var spec$ = Stream.Subject();
  var pay$ = Stream.fromEvent(document.getElementById('pay-btn'), 'click');
  var selectSpec$ = Stream.combine(spec$.startWith(''), payMethod$.startWith(''));
  var resetSpecInEveryTime = false; // 每次打开面板都需要重置选中的参数？

  // 购买方法的选中流
  payMethod$.addListener({
    next(key) {
      slice.call(document.getElementById('product-pay-method').children).forEach(node => {
        if (node.getAttribute('data-key') === key) node.classList.add('active');
        else node.classList.remove('active');
      });
    }
  });

  // 子类测评的选中流
  spec$.addListener({
    next(key) {
      if (document.getElementById('product-spec')) {
        slice.call(document.getElementById('product-spec').children).forEach(node => {
          node = node.querySelector('.cp-tag');
          if (node.getAttribute('data-key') === key) {
            node.classList.add('active');
          } else {
            node.classList.remove('active');
          }
        });
      }
    }
  });

  if (document.getElementById('product-pay-method')) {
    document.getElementById('product-pay-method').addEventListener('click', function (e) {
      var $data = dom.closest(e.target, 'li');
      if ($data) {
        payMethod$.next($data.getAttribute('data-key'));
      }
    });
  }

  if (document.getElementById('product-spec')) {
    hasChildScale = true;
    document.getElementById('product-spec').addEventListener('click', function (e) {
      var $data = dom.closest(e.target, '.cp-tag');

      if ($data) {
        spec$.next($data.getAttribute('data-key'));
      }
    });
  }

  let {userId, channelId, userKey} = requiredParams;
  // 加载页面，检查是否有三分钟内的微信H5支付订单
  buyFuns.pageLoadCheckWxH5Order(Object.assign({}, requiredParams, {
    pageScaleId: scalePoolId,
    userInfo: {userId, channelId, userKey},
    urlOrderId: GetQueryString('orderId'),
    payType: isDepression ? 'depression' : ''
  }));

  // 重置客服事件
  function resetServiceEvent () {
    let btn = e('#service-btn')
    btn.addEventListener('click', (event) => {
      let self = event.target.closest('#service-btn')
      if (!self) {
        return
      }
      let tipText = e('.service-tips-wrap')
      if (tipText) {
        tipText.remove()
      }
      let dialogHtml = `
      <div class="service-dialog">
        <div class="mask"></div>
        <div class="dialogWin" >
          <i class="close fs-18" >×</i>
          <div class="fs-16 content noTitle">
            <div>答题或查看报告过程有疑问，请添加客服微信，解决您的问题。</div>
          </div>
          <div class="service-qrcode" slot="content">
            <img class="qrcode" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/e0355eed391b468bbafe565cb6223375.jpg"/>
          </div>
          <div class="action">
            <div class="btnCont" >
              <div class="btn fs-16 btn--yellow">好的</div>
            </div>
          </div>
        </div>
      </div>
      `
      e('#app').insertAdjacentHTML('beforeend', dialogHtml)

      function removeServiceDialogBox() {
        e('.service-dialog').remove()
      }

      e('.service-dialog .close').addEventListener('click', () => {
        removeServiceDialogBox()
      })
      e('.service-dialog .btnCont').addEventListener('click', () => {
        removeServiceDialogBox()
      })
    })
  }
  resetServiceEvent()

  // 初始化优惠券弹窗
  async function initCouponBox() {
    if (GetQueryString('sourceName') == '525zhc') return
    couponDialogData = await getCouPonBoxData()
    // let couponData = await getCouPonBoxData()
    log('--- 优惠券弹窗的数据 --- couponDialogData', couponDialogData)
    if (couponDialogData && couponDialogData.length != 0) {
      let couponDialogEndTime = {
        day: 0,
        hr: 0,
        min: 0,
        sec: 0
      }
      let initPropTime = couponDialogData.expireTime
      function initCurrentTime() {
        let day = parseInt(initPropTime / 1000 / 60 / 60 / 24);
        let hr = parseInt((initPropTime / 1000 / 60 / 60) % 24);
        let min = parseInt((initPropTime / 1000 / 60) % 60);
        let sec = parseInt((initPropTime / 1000) % 60);
        couponDialogEndTime.day = day;
        couponDialogEndTime.hr = hr > 9 ? hr : "0" + hr;
        couponDialogEndTime.min = min > 9 ? min : "0" + min;
        couponDialogEndTime.sec = sec > 9 ? sec : "0" + sec;
      }
      initCurrentTime()

      let html = `
      <div class="coupon-dialog">
        <div class="mask"></div>
        <div class="firework-grp">
          <div class="firework pos1">
            <div class="drops-grp">
              <span class="drop drop-1"></span>
              <span class="drop drop-2"></span>
              <span class="drop drop-3"></span>
              <span class="drop drop-4"></span>
            </div>
            <div class="drops-grp drops-grp2">
              <span class="drop drop-1"></span>
              <span class="drop drop-2"></span>
              <span class="drop drop-3"></span>
              <span class="drop drop-4"></span>
            </div>
          </div>
          <div class="firework pos2 delay1">
            <div class="drops-grp">
              <span class="drop drop-1"></span>
              <span class="drop drop-2"></span>
              <span class="drop drop-3"></span>
              <span class="drop drop-4"></span>
            </div>
            <div class="drops-grp drops-grp2">
              <span class="drop drop-1"></span>
              <span class="drop drop-2"></span>
              <span class="drop drop-3"></span>
              <span class="drop drop-4"></span>
            </div>
          </div>
          <div class="firework pos4 delay2">
            <div class="drops-grp">
              <span class="drop drop-1"></span>
              <span class="drop drop-2"></span>
              <span class="drop drop-3"></span>
              <span class="drop drop-4"></span>
            </div>
            <div class="drops-grp drops-grp2">
              <span class="drop drop-1"></span>
              <span class="drop drop-2"></span>
              <span class="drop drop-3"></span>
              <span class="drop drop-4"></span>
            </div>
          </div>
        </div>
        <div class="dialogWin">
          <div class="title fs-18"></div>
          <slot name="top"></slot>
          <div class="fs-16 content">
            <div class="subtitle">${couponDialogData.subtitle ? couponDialogData.subtitle : '你被优惠券砸中啦'}</div>
            <div class="coupon">
              <div class="coupon-title">
                <div class="intitle">${couponDialogData.popTitle}</div>
                ${couponDialogData.popDescription ? `
                <div class="intis">${couponDialogData.popDescription}</div>
                ` : ''}
              </div>
              <div
                class=${couponDialogData.popCouponTypeDes.length > 4 ? 'coupon-price-min' : 'coupon-price'}
              >${couponDialogData.popCouponTypeDes}</div>
            </div>
            <div class="dialog-timer">
              <div class="timer-title">${couponDialogData.expireTimeTitle ? couponDialogData.expireTimeTitle : '优惠券有效时间'}</div>
              ${couponDialogData.expireTime ? `
              <div class="timer-tis">
                ${couponDialogEndTime.day ? `<span>${couponDialogEndTime.day}天</span>` : ''}
                <span>${couponDialogEndTime.hr}</span>:
                <span>${couponDialogEndTime.min}</span>:
                <span>${couponDialogEndTime.sec}</span>
              </div>` : ''
      }
            </div>
          </div>
          <div class="action">
            <div class="btnCont">
              <div class="inbtn fs-16 couponDialog-use">立即使用</div>
            </div>
          </div>
          <v-touch class="couponDialog-close">
            <img src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/4377a3c3087542bfa6fe9c3b6a41306e.png" />
          </v-touch>
        </div>
      </div>
    `
      e('#app').insertAdjacentHTML('beforeend', html)

      function runLoopTime() {
        //倒计时结束
        if (initPropTime < 2) {
          return;
        }
        initPropTime = initPropTime - 1000;
        initCurrentTime()
        let timeHtml = `
        <div class="timer-tis">
          ${couponDialogEndTime.day ? `<span>${couponDialogEndTime.day}天</span>` : ''}
          <span>${couponDialogEndTime.hr}</span>:
          <span>${couponDialogEndTime.min}</span>:
          <span>${couponDialogEndTime.sec}</span>
        </div>
      `
        let timeDom = e('.coupon-dialog .timer-tis')
        if (timeDom) {
          timeDom.outerHTML = timeHtml
        }
        let timer = setTimeout(function() {
          runLoopTime();
          clearTimeout(timer);
        }, 1000);
      }
      runLoopTime()

      function removeCouponDialogBox() {
        initPropTime = 0
        e('.coupon-dialog').remove()
      }

      e('.coupon-dialog .couponDialog-use').addEventListener('click', () => {
        removeCouponDialogBox()
        if (platform.isYixinliApp && couponDialogData.scope != 3) {
          location.href = 'yixinli://open_test_home'
        }
      })
      e('.coupon-dialog .couponDialog-close').addEventListener('click', () => {
        removeCouponDialogBox()
      })
    }
  }

  function getCouPonBoxData() {
    return new Promise(resolve => {
      let sourceName = GetQueryString("sourceName")
      axios.get(`${APIS.lingxiHost}coupon/receiveCoupon`, {
        params: {
          channelId: Number(requiredParams.channelId),
          displayPlace: 2,  // 详情页
          sourceName: (sourceName && sourceName != 'null') ? sourceName : '',
          scalePoolId: Number(scalePoolId),
          userKey: requiredParams.userKey,
        }
      }).then(res => {
        if (res.data.code == '1') {
          const data  = res.data.data
          resolve(data)
        }
      })
    })
  }
  let couponDialogData = {}
  initCouponBox()
  cpVipData = await requestVipInfo()
  // cpVipData.vipStatus = 2

  // 2020 双十一活动
  // 是单测评，还是 测评 + 咨询
  let payName20201111
  let payData20201111
  function showPayPanel20201111() {
    var $dialog = document.querySelector('.pay-panel-wrap');
    $dialog.style.display = '';
    // $dialog.clientHeight;
    $dialog.classList.remove('pay-panel-wrap--close');
    // 添加默认支付方式
    let payDom = document.querySelector('#product-pay-method .active')
    if (!payDom) {
      payDom = document.querySelector('#product-pay-method li')
      payDom.classList.add('active')
    }
    // 选择默认子类型
    if (document.getElementById('product-spec')) {
      let specSelect = document.querySelector('#product-spec .cp-tag')
      specSelect.classList.add('active')
    }
    // 重置参数选择
    if (resetSpecInEveryTime) {
      payMethod$.next('');
      spec$.next('');
    }
  }
  function bindEventPayBtn() {
    let payBtn = e('#pay-btn')
    payBtn.addEventListener('click', (event) => {
      let payDom = document.querySelector('#product-pay-method .active')
      if (!payDom) {
        payDom = document.querySelector('#product-pay-method li')
      }
      let tradeType = payDom.getAttribute('data-key')
      selectedTredeType = tradeType
      if (platform.isYixinliApp) {
        if (selectedTredeType == "ALI_PAY_WAP") {
          selectedTredeType = 'ALI_PAY_APP'
        } else if (selectedTredeType == "WX_H5_PAY") {
          selectedTredeType = 'WX_PAY_APP'
        }
      }
      // 没有 userKey 先去登陆
      if (!requiredParams.userKey) {
        if (platform.isYixinliApp) {
          // 壹心理APP 走登录协议
          location.href = 'yixinli://open_user_login';
        } else if (platform.isPc) {
          // PC站，使用PC登录页
          location.href = `https://account${APIS.env}.xinli001.com/login?next=${encodeURIComponent(detailUrl)}`;
        } else {
          // 其他情况，如M站、口袋心理，使用旧版登录页，并且登录完会自动触发autoBuy，
          // referer 表示登录页不点击APP标题栏返回，点击了页面上的返回，去的地方
          location.href = `https://m${APIS.env}.xinli001.com/account/login-for-ceping?callbackUrl=${encodeURIComponent(`https://m${APIS.env}.xinli001.com/ceping/${scalePoolId}?channelId=${channelId}&autoBuy=1&userKey=`)}&referer=${backUrl}`;
        }
        return
      }

      let params = {
        channelId: Number(requiredParams.channelId),
        userKey: requiredParams.userKey ? requiredParams.userKey : '',
        tradeType: selectedTredeType,
        goonBuy: 0,
      }
      params[payName20201111] = payData20201111[payName20201111]

      // 获取子类测评id
      if (document.getElementById('product-spec')) {
        let specSelect = document.querySelector('#product-spec .active')
        console.log('--- 选取的子类 id 是 ---', specSelect.getAttribute('data-key'))
        params['scalePoolId'] = specSelect.getAttribute('data-key')
      }

      buyFuns.buyDoubleElevenRequest(params).toPromise().then(res => {
        console.log('--- 详情页支付回调 --- res', res)
        let payType = 'doubleEleven2020'
        return buyFuns.afterBuy(res, params, requiredParams.userKey, payType);
      })
    })
  }
  function bindEventPayRightAll(data) {
    let btnRight = e('.doubleEleven20-right-all')
    btnRight.addEventListener('click', (event) => {
      // console.log('--- 选中了右边按钮 ---', btnRight)

      payName20201111 = 'packageId'
      payData20201111 = data
      showPayPanel20201111()
    })
  }
  function bindEventPayRight(data) {
    let btnRight = e('.doubleEleven20-right-half')
    btnRight.addEventListener('click', (event) => {
      // console.log('--- 选中了右边按钮 ---', btnRight)

      payName20201111 = 'packageId'
      payData20201111 = data
      showPayPanel20201111()
    })
  }
  function bindEventPayLeft(data) {
    let btnLeft = e('.doubleEleven20-left-half')
    btnLeft.addEventListener('click', (event) => {
      // console.log('--- 选中了左边按钮 ---', btnLeft)

      payName20201111 = 'scalePoolId'
      payData20201111 = data
      showPayPanel20201111()
    })
  }
  function bindEvents(data) {
    if (data.length == 2) {
      bindEventPayLeft(data[0])
      bindEventPayRight(data[1])
    } else {
      bindEventPayRightAll(data[0])
    }

    bindEventPayBtn()
  }
  function append20201111BtnHtml(dom, pricePlan) {
    let html = ''
    if (pricePlan.length == 2) {
      let left = pricePlan[0]
      let right = pricePlan[1]
      html = `
      <div class="doubleEleven20-btn" style="touch-action: manipulation; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
        <div class="doubleEleven20-left-half">
          <div class="left-btnName">${left.buttonName}</div>
          <div class="left-price">¥${left.price}</div>
        </div>
        <div class="doubleEleven20-right-half">
          <div class="right-btnName-1">${right.buttonName.substring(0, right.buttonName.indexOf('+'))}</div>
          <div class="right-btnName-2">${right.buttonName.substring(right.buttonName.indexOf('+'), right.buttonName.length)}</div>
          <div class="right-price">¥${right.price}</div>
        </div>
      </div>
    `
    } else if (pricePlan[0].packageId != 0) {
      let right = pricePlan[0]
      html = `
        <div class="doubleEleven20-btn" style="touch-action: manipulation; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
          <div class="doubleEleven20-right-all">
            <div class="right-btnName-1">${right.buttonName.substring(0, right.buttonName.indexOf('+'))}</div>
            <div class="right-btnName-2">${right.buttonName.substring(right.buttonName.indexOf('+'), right.buttonName.length)}</div>
            <div class="right-price">¥${right.price}</div>
          </div>
        </div>
      `
    }

    dom.insertAdjacentHTML('afterend', html)
  }
  function doubleEleven2020() {

    if (!isActivity20201111) {
      return
    }
    let foot = e('.art-handler')
    foot.style.visibility = 'hidden'
    let price = e('.art-price')
    price.style.display = 'none'
    let params = {
      channelId: Number(requiredParams.channelId),
      scalePoolId: scalePoolId,
      userKey: requiredParams.userKey ? requiredParams.userKey : ''
    }
    axios.get('/lx/doubleEleven/getScalePricePlan', {params: params}).then(res => {
      console.log('--- 获取到的按钮信息 ---', res.data)
      let data = res.data
      if (data.code == 1) {
        let pricePlan = data.data
        append20201111BtnHtml(foot, pricePlan)
        bindEvents(pricePlan)
      } else {
        console.log('--- 按钮数据请求异常 ---')
      }
    })
  }
  doubleEleven2020()

  //2019年中活动入口
  addCpeighthEntrance()
  function addCpeighthEntrance() {
    let div = document.createElement('div');
    div.className='cp-eighth-entrance'
    div.innerHTML =`<img src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/b49e473b952343db9a743693ba342ec7.gif">`
    document.body.appendChild(div);
  }
  let endData = 1564156799000
  let newData = new Date().getTime()
  let showLog =  parseInt(endData) - parseInt(newData) > 0
  if(document.querySelector('.cp-eighth-entrance')){
    document.querySelector('.cp-eighth-entrance').addEventListener('click', function (e) {
      let {channelId, userKey} = requiredParams;

      hideShareBtn()
      window.location.href = `https://static${APIS.env !== '' ? APIS.env :''}.xinli001.com/cp/index.html?init=26#/vip4Detail?channelId=${channelId}&userKey=${userKey}&enterFrom=logo`
    });
  }
  //过期||pc
  if(!showLog||platform.isPc){
    document.querySelector('.cp-eighth-entrance').style.display="none"
  }


  // 测评优惠券选项
  function couponUseBarText(data) {
    let result = ''
    if (data.length > 0) {
      let selectedCoupon = data[0]
      if (selectedCoupon && selectedCoupon.uuid === undefined) {
        result = '不使用优惠券'
      } else {
        result = selectedCoupon.couponDescribe
      }
    } else {
      result = '无可用优惠券';
    }
    return result;
  }
  function initPrice(data) {
    let actualPrice = e('.art-price').innerText.split(' ')[0].replace('￥', '')
    let price = actualPrice
    if (data.length > 0) {
      let coupon = data[0]
      // 同时初始化优惠券 uuid
      console.log('--- 选择的优惠券数据 --- coupon', coupon)
      uuid = coupon.uuid
      // couponType    类型: 1限免 2满减 3折扣 4随机 5代金券
      if (coupon && coupon.uuid) {
        if ([1, 3].includes(coupon.couponType)) {
          price = (price * coupon.discountRate).toFixed(2)
        } else if ([4, 5].includes(coupon.couponType)) {
          let subtractPrice = coupon.couponDescribe.slice(1)
          let totalPrice = Number(price) - Number(subtractPrice)
          price = totalPrice > 0 ? totalPrice.toFixed(2) : '0.00'
        } else if (coupon.couponType === 2) {
          let subtractPrice = coupon.subtractPrice / 100
          let totalPrice = Number(price) - Number(subtractPrice)
          price = totalPrice > 0 ? totalPrice.toFixed(2) : '0.00'
        }
      }
    }

    // 抑郁单品
    if (isDepression) {
      return depressionPrice
    }
    return price
  }
  function loadPanelHtml(data, vipData) {
    // 优惠券三种状态：无可用优惠券、不使用优惠券、折扣券
    let discount = couponUseBarText(data)
    let price = initPrice(data)
    let html = `
      <div class="pannel coupon fs-14 ${isAPP ? '' : 'border'}" style="touch-action: manipulation; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
        <span for="useCoupon" class="field-label">优惠券</span>
        <span class="field-text text--right">${discount}</span>
        <span class="yxlCp-icon yxlCp-icon-more"></span>
      </div>
      <div class="panel cp-vip ${[9, 10].includes(vipData.vipIdentity) && vipData.vipStatus === 1 ? 'is-vip' : 'not-vip'}">
        <div class="not-vip-box">
          <div class="box-price ${vipData.inActivityTime ? '' : 'box-center'}">
            <span class="price">
              ￥${vipData.discoutPrice.toFixed(1)}
            </span>
            ${vipData.inActivityTime ? `<span class="origin-price">原价￥${vipData.originPrice.toFixed(1)}</span>` : ''}
          </div>
          <div class="cp-vip-box-select"></div>
          ${vipData.inActivityTime ? '<span class="box-activity-text"><p>立减70元</p></span>' : '<span class="box-activity-text"><p>推荐升级</p></span>'}
        </div>
      </div>
      <div class="pannel totalCost">
        <p class="text--right fs-14">
        合计：<span>￥${price}</span></p>
      </div>
    `
    let bro = e('.pay-action-area')
    bro.insertAdjacentHTML('afterend', html)
  }
  function couponHtml(data, i) {
    let title = data.remark
    let desc = data.description
    let date = `有效期至${data.startTime.replace('-', '.')}-${data.endTime.replace('-', '.')}`
    let describe = data.couponDescribe
    let discountRate = data.discountRate
    let uuid = data.uuid
    let subtractprice = data.subtractPrice
    let coupontype = data.couponType
    let discount = coupontype === 2 ? ('￥' + (subtractprice / 100).toFixed(2)) : describe
    let isSubtract = coupontype === 2 ? 'block' : 'none'
    let selected = i === 0 ? 'selected' : ''
    let html = `
      <div class="cpCoupon ${selected}" data-coupondescribe=${describe} data-discountrate=${discountRate} data-uuid=${uuid} data-subtractprice=${subtractprice} data-coupontype=${coupontype}
        style="touch-action: manipulation; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); pointer-events: auto;">
        <div class="coupon-context">
          <div class="coupon-title fs-14">${title}</div>
          <div class="coupon-desc fs-12">${desc}</div>
          <div class="coupon-date fs-12">${date}</div>
        </div>
        <div class="coupon-value free">
          <div class="discount">${discount}</div>
          <div class="discount-tis" style="display: ${isSubtract}">${describe}</div>
        </div>
      </div>
    `
    return html
  }
  function couponsHtml(data) {
    // 传入每个优惠券的数据
    let html = ''
    for (let i = 0; i < data.length; i++) {
      let d = data[i]
      html += couponHtml(d, i)
    }
    return html
  }
  function selectCouponHtml(data) {
    let coupons = couponsHtml(data)
    let html = `
      <div class="selectCoupon rightLeave">
        <div class="fs-14 yxlCp-icon yxlCp-btn-back" style="touch-action: manipulation; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);"></div>
        <div class="fs-14 color--main notUseCoupon" style="touch-action: manipulation; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">不使用优惠券</div>
        <div class="couponList">
          <ul style="transition-property: transform; transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1); transition-duration: 0ms; transform: translate(0px, 0px) translateZ(0px);">
            <!--这里放入获取的所有优惠券-->
            ${coupons}
          </ul>
          <div class="bscroll-vertical-scrollbar" style="position: absolute; z-index: 9999; width: 7px; bottom: 2px; top: 2px; right: 1px; overflow: hidden; opacity: 0; transition-duration: 500ms;">
            <div class="bscroll-indicator" style="box-sizing: border-box; position: absolute; background: rgba(0, 0, 0, 0.5); border: 1px solid rgba(255, 255, 255, 0.9); border-radius: 3px; width: 100%; transition-duration: 0ms; height: 139px; transform: translateY(0px) translateZ(0px); transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);"></div>
          </div>
        </div>
      </div>
    `
    let father = e('.pay-panel-wrap')
    father.insertAdjacentHTML('beforeend', html)
  }
  function pageAnimation(payPanel, selectCoupon, payIsShow) {
    if (payIsShow) {
      payPanel.classList.remove('leftEntry')
      payPanel.classList.add('leftLeave')
      selectCoupon.style.display = 'block'
      selectCoupon.classList.remove('rightLeave')
      selectCoupon.classList.add('rightEntry')
      let timeId = setTimeout(function () {
        payPanel.style.display = 'none'
        clearInterval(timeId)
      }, 300)
    } else {
      selectCoupon.classList.remove('rightEntry')
      selectCoupon.classList.add('rightLeave')
      payPanel.style.display = 'block'
      payPanel.classList.remove('leftLeave')
      payPanel.classList.add('leftEntry')
      let timeId = setTimeout(function () {
        selectCoupon.style.display = 'none'
        clearInterval(timeId)
      }, 300)
    }
  }
  function togglePayPage() {
    let payPanel = e('.pay-panel')
    let selectCoupon = e('.selectCoupon')
    let payDisplay = payPanel.style.display
    let payIsShow = payDisplay === 'block'
    // 进行动画
    pageAnimation(payPanel, selectCoupon, payIsShow)
    // 只有优惠券页面能滚动
    let html = e('html')
    html.style.overflowY = html.style.overflowY === 'scroll' ? 'hidden' : 'scroll'
  }
  function initPageStatus() {
    e('.pay-panel').style.display = 'block'
    e('.selectCoupon').style.display = 'none'
    e('html').style.overflowY = 'scroll'
  }
  function entryCouponEvent(data) {
    let panel = e('.pannel')
    panel.addEventListener('click', function () {
      if (data.length > 0) {
        goSelectCouponTrack()
        togglePayPage()
      } else {
        toast('没有可使用的优惠券')
      }
    })
  }
  function changeDescribeAndRate(coupon) {
    let t = e('.coupon .field-text')
    t.innerText = coupon.coupondescribe
    let price = e('.art-price').innerText.split(' ')[0].replace('￥', '')
    let p = e('.totalCost span')
    console.log('--- 选择的优惠券数据 --- coupon', coupon)
    if (coupon && coupon.uuid) {
      // couponType    类型: 1限免 2满减 3折扣 4随机 5代金券
      if ([1, 3].includes(coupon.couponType)) {
        price = (price * coupon.discountRate).toFixed(2)
      } else if ([4, 5].includes(coupon.couponType)) {
        console.log('--- 进入 4，5 条件 --- coupon.couponDescribe',)
        let subtractPrice = coupon.coupondescribe.slice(1)
        let totalPrice = Number(price) - Number(subtractPrice)
        console.log('--- totalPrice ---', totalPrice)
        price = totalPrice > 0 ? totalPrice.toFixed(2) : '0.00'
      } else if (coupon.couponType === 2) {
        let subtractPrice = Number(coupon.subtractPrice) / 100
        let totalPrice = Number(price) - Number(subtractPrice)
        price = totalPrice > 0 ? totalPrice.toFixed(2) : '0.00'
      }
    }
    p.innerText = `￥${price}`
  }
  function toggleSelected(newEle = undefined) {
    let oldEle = e('.cpCoupon.selected')
    if (oldEle) {
      oldEle.classList.remove('selected')
    }
    if (newEle) {
      newEle.classList.add('selected')
    }
  }
  function notUseCouponEvent() {
    let notUse = e('.notUseCoupon')
    notUse.addEventListener('click', function() {
      uuid = undefined
      let selectedCoupon = {
        coupondescribe: '不使用优惠券',
        discountRate: 1
      }
      noUseCouponTrack()
      changeDescribeAndRate(selectedCoupon)
      toggleSelected()
      togglePayPage()
    })
  }
  function selectCouponEvent() {
    let selectCoupon = e('.selectCoupon')
    selectCoupon.addEventListener('click', function(e) {
      let self = e.target.closest('.cpCoupon')
      if (self) {
        let cpCoupon = self.classList.contains('cpCoupon')
        if (cpCoupon) {
        // data-coupondescribe=${describe} data-discountrate=${discountRate} data-uuid=${uuid} data-subtractprice=${subtractprice} data-coupontype=${coupontype}
          let describe = self.dataset.coupondescribe
          let rate = self.dataset.discountrate
          let subtractprice = self.dataset.subtractprice
          let coupontype = parseInt(self.dataset.coupontype, 10)
          uuid = self.dataset.uuid
          let selectedCoupon = {
            coupondescribe: describe,
            discountRate: rate,
            subtractPrice: subtractprice,
            couponType: coupontype,
            uuid: uuid
          }
          inSelectCouponTrack()
          toggleSelected(self)
          changeDescribeAndRate(selectedCoupon)
          togglePayPage()
        }
      }
    })
    selectCoupon.addEventListener('scroll', function(e) {
      let self = e.target.closest('.couponList')
      if (self) {
        let cpCouponList = self.classList.contains('couponList')
        if (cpCouponList) {
          self.stopPropagation()
        }
      }
    })
  }
  function backPayPageEvent() {
    let backButton = e('.selectCoupon .yxlCp-btn-back')
    backButton.addEventListener('click', function () {
      togglePayPage()
    })
  }
  function goSelectCouponTrack() {
    myTracker.send({
      name: '访问“选择优惠券”页',
      properties: {
        '测评名称': scaleName,
      }
    })
  }
  function noUseCouponTrack() {
    myTracker.send({
      name: '点击“不使用优惠券”',
      properties: {
        '测评名称': scaleName,
      }
    })
  }
  function inSelectCouponTrack() {
    myTracker.send({
      name: '点击“确认付款-选择优惠券”按钮',
      properties: {
        '测评名称': scaleName,
      }
    })
  }
  function cpVipSelectEvent(couponData, cpVipData) {
    const vipBtn = e('.panel.cp-vip')
    vipBtn && vipBtn.addEventListener('click', function(event) {
      let vipSelectClassList = e('.cp-vip-box-select').classList
      if (vipSelectClassList.contains('is-select')) {
        vipSelectClassList.remove('is-select')
        isBuyCpVip = false
        // 显示优惠券
        e('.pannel.coupon').style.display = 'flex'
        let price = initPrice(couponData)
        e('.pannel.totalCost span').innerText = `￥${price}`
        let discount = couponUseBarText(couponData)
        e('.coupon .field-text').innerText = discount
      } else {
        vipSelectClassList.add('is-select')
        isBuyCpVip = true
        // 不展示优惠券
        e('.pannel.coupon').style.display = 'none'
        let price = cpVipData.discoutPrice
        e('.pannel.totalCost span').innerText = `￥${price}`

        // 测评-支付弹窗-勾选购买测评会员
        appTrackEvent('ceping_purchasepop_pickbuyvip', {
          test_id: scalePoolId,
          test_name: scaleName,
          test_channel_id: channelId,
          test_channel_name: '壹心理APP',
        })
      }
    })
  }
  function selectProtocolEvent() {
    let selectProtocol = e('.selectProtocol')
    selectProtocol && selectProtocol.addEventListener('click', function(e) {
      let selectBtn = e.target.closest('.select-icon')
      if (selectBtn) {
        let btnClassList = selectBtn.classList
        if (btnClassList.contains('check')) {
          btnClassList.remove('check')
          document.getElementById('pay-btn').classList.add('cp-btn--disabled');
        } else {
          btnClassList.add('check')
          // 判断其他选项有没有选中
          slice.call(document.getElementById('product-pay-method').children).forEach(node => {
            // 支付方式
            if (node.classList.contains('active')) {
              if (document.getElementById('product-spec')) {
                slice.call(document.getElementById('product-spec').children).forEach(node => {
                  // 版本
                  node = node.querySelector('.cp-tag');
                  if (node.classList.contains('active')) {
                    console.log('=== 都选了 ===')
                    document.getElementById('pay-btn').classList.remove('cp-btn--disabled');
                  }
                });
              } else {
                document.getElementById('pay-btn').classList.remove('cp-btn--disabled');
              }
            }
          });
        }
      }

      let protocolBtn = e.target.closest('.protocol-text')
      if (protocolBtn) {
        let url = "https://m.xinli001.com/richtext/protocol-cp-toufang"
        jumpMethods.openUrl(url);
      }
    })
  }

  function payPanelEvents(couponData, cpVipData) {
    // 在优惠券选择页面点击进入优惠券页面
    entryCouponEvent(couponData)
    // 在优惠券页面绑定事件
    notUseCouponEvent(couponData)
    selectCouponEvent(couponData)
    backPayPageEvent()

    // app 内购买测评会员
    if (isAPP) {
      if ([9, 10].includes(cpVipData.vipIdentity) && cpVipData.vipStatus === 1) {
        // 未过期会员6.0没有交互
      } else {
        cpVipSelectEvent(couponData, cpVipData)
      }
      selectProtocolEvent()
    }
  }
  function requestCoupon() {
    let { channelId } = requiredParams
    let category = e('#res-category').dataset.category
    let params = {
      channelId: channelId,
      category: category,
      scalePoolId: scalePoolId
    }
    return new Promise(resolve => {
      axios.get(`${APIS.cpapiHost}coupon/getScalePoolCouponList`, {
        params: params,
      }).then(res => {
        let {code, data, msg} = res.data
        resolve(data || [])
      })
    })
  }
  function requestVipInfo() {
    return new Promise(resolve => {
      axios.get(`${APIS.lingxiHost}vip/v4/getVipHomePageInfo`, {
        params: {
          channelId: requiredParams.channelId,
          userKey: requiredParams.userKey || '35575794488809881620',
          scalePoolId: scalePoolId,
        }
      }).then(res => {
        let {code, data, msg} = res.data
        resolve(data)
      })
    })
  }
  function hiddenCpVipDom() {
    e('.panel.cp-vip').style.display = 'none'
  }
  function selectProtocolHtml() {
    let html = `
      <div class="panel selectProtocol" id="product-protocol">
        <div class="select-icon"></div>
        <div class="select-content">
          同意<span class="protocol-text">《心理测评服务协议》</span>立即开始测试
        </div>
      </div>
    `
    let bro = e('.pay-panel .i-tips')
    bro.insertAdjacentHTML('afterend', html)
  }
  let insertCoupon = async function() {
    let couponData = await requestCoupon()
    // cpVipData = await requestVipInfo()
    console.log('=== couponData ===', couponData)
    console.log('=== cpVipData ===', cpVipData)
    // 加载优惠券选项及选择优惠券页面
    loadPanelHtml(couponData, cpVipData)
    selectCouponHtml(couponData)
    if (isAPP) {
      let selectProtocolVisible = true
      if (cpVipData.vipStatus == 1 && [9, 10].includes(cpVipData.vipIdentity) && !cpVipData.vipScalePoolFree) {
        // 6.0 会员没有免费次数不展示
        hiddenCpVipDom()
      } else if (cpVipData.vipStatus == 1 && cpVipData.vipScalePoolFree) {
        // 会员且有免费次数
        selectProtocolVisible = false
      }
      selectProtocolVisible && selectProtocolHtml()
    } else {
      // app 外不展示
      hiddenCpVipDom()
    }
    // 初始化页面状态
    initPageStatus()
    // 加载优惠券事件
    payPanelEvents(couponData, cpVipData)

    // 测评-支付弹窗展示, 第 1 次打开
    appTrackEvent('weizhan_cepingpurchasepop_view', {
      test_id: scalePoolId,
      test_name: scaleName,
      test_channel_id: channelId,
      test_channel_name: '壹心理APP',
      vip_status: cpVipData ? cpVipData.vipStatus == 1 : false
    })

    insertCoupon = () => {}
  }

  // 双十二年费会员
  function initDoubleTwelveVip() {
    let eventBtns = {
      '.buy-vip': '测评详情页-底部按钮',
      '.vip-content': '测评详情页-会员免费测',
    }
    let buttons = Object.keys(eventBtns)
    for (let i = 0; i < buttons.length; i++) {
      let btn = buttons[i]
      let ele = document.querySelector(btn)
      if (ele) {
        ele.addEventListener('click', function () {
          console.log('会员活动入口：', eventBtns[btn])
          myTracker.send({
            name: '测评-页面交互',
            properties: {
              '会员活动入口': eventBtns[btn],
            }
          })
          myTracker.send({
            name: '会员升级2020--页面访问',
            properties: {
              '页面名称': '会员2020-测评详情页-会员免费按钮',
              '渠道ID': channelId,
              '来源域名': location.hostname
            }
          })
          let userKey = requiredParams.userKey ? requiredParams.userKey : ''

          hideShareBtn()
          let targetUrl = `https://static${APIS.env !== '' ? APIS.env :''}.xinli001.com/cp/index.html?init=26#/vip4Detail?channelId=${channelId}&userKey=${userKey}`
          window.userleft = true
          window.location.href = targetUrl
        })
      }
    }
  }
  // 灰盒测试 2019-12-20 17点后再显示
  let testStartTime = new Date('2019/12/20 17:00').getTime()
  let testNowTime = new Date().getTime()
  if (testNowTime > testStartTime) {
    initDoubleTwelveVip()
    doubleTwelveVipToast()
  } else {
    // 隐层图标
    let btns = ['.buy-vip', '.vip-content']
    for (let i = 0; i < btns.length; i++) {
      let b = document.querySelector(btns[i])
      if (b) {
        b.style.display = 'none'
      }
    }
  }

  hiddenisCeShiAppVip()

  function hiddenisCeShiAppVip(){
    if (platform.isCeShiApp) {
    // 口袋心理app
      document.querySelector('.buy-vip').style.display = 'none'
    }
  }
  // initDoubleTwelveVip()

  // 双十二会员弹窗
  function appendVipHtml() {
    let html = `
      <div class="cp-vip-toast" style="touch-action: manipulation; user-select: none; -webkit-user-drag: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);">
        <img class="vip-toast memberLogo-1 show" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/5eff301d931d47949c2136b4021092a4.png">
        <img class="vip-toast memberLogo-2" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/dfed4bf888f641219a9bfe3f812e62f9.png">
        <img class="vip-toast logo1-1" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/f6a246e118ef41819defc0200e855fb5.png">
        <img class="vip-toast logo1-2" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/5c1ca5c5eb4c4df8a67296cc8499d5ce.png">
        <img class="vip-toast logo2-1" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/a943b36e23c44bd6a5712ba93233f388.png">
        <img class="vip-toast logo2-2" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/f2faa7c48fb543e5bff9db85ec777bf0.png">
        <img class="vip-toast logo3-1" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/ead6c4e4036a4d8db83832f6be7c01ec.png">
        <img class="vip-toast logo3-2" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/e0dd83fc97c64864a039fda478a6e51f.png">
      </div>
    `
    document.body.insertAdjacentHTML('beforeend', html)
  }
  function ACTIVITYSLASTYPE() {
    let beginData1 = new Date('2019/12/29 00:00').getTime()
    let beginData2 = new Date('2019/12/30 00:00').getTime()
    let beginData3 = new Date('2019/12/31 00:00').getTime()
    let END_TIME = new Date('2020/1/1 00:00').getTime()
    let newData = new Date().getTime()
    if (newData > END_TIME) {
      return -1
    } else if (newData > beginData3) {
      return 1
    } else if (newData > beginData2) {
      return 2
    } else if (newData > beginData1) {
      return 3
    } else {
      return 0
    }
  }
  function toggleImg(activityType, showType) {
    if (activityType < 0) {
      return
    }
    let o = {
      0: '.memberLogo-',
      1: '.logo1-',
      2: '.logo2-',
      3: '.logo3-'
    }
    let activityClass = `${o[activityType]}${showType}`
    let father = document.querySelector('.cp-vip-toast')
    father.querySelector('.show').classList.remove('show')
    father.querySelector(activityClass).classList.add('show')
  }
  function toggleShow(type) {
    // 判断第几张图片
    let showType = type ? 1 : 2
    // 判断时间范围
    let activityType = ACTIVITYSLASTYPE()
    toggleImg(activityType, showType)
    // 活动时间范围内自动切换
    if (activityType > -1) {
      let timer = setTimeout(() => {
        toggleShow(!type);
        clearTimeout(timer);
      }, 200);
    } else {
      document.querySelector('.cp-vip-toast').style.display = 'none'
    }
  }
  function doubleTwelveVipToast() {
    let activityType = ACTIVITYSLASTYPE()
    if (activityType < 0 || platform.isPc) {
      return
    }
    // 插入弹窗html
    appendVipHtml()
    // 切换显示图片
    toggleShow()
    let father = document.querySelector('.cp-vip-toast')
    father.addEventListener('click', function () {
      let userKey = requiredParams.userKey ? requiredParams.userKey : ''
      myTracker.send({
        name: '测评-页面交互',
        properties: {
          '会员活动入口': '详情页浮标',
        }
      })

      hideShareBtn()
      let targetUrl = `https://static${APIS.env !== '' ? APIS.env :''}.xinli001.com/cp/index.html?init=26#/vip4Detail?channelId=${channelId}&userKey=${userKey}`
      window.userleft = true
      window.location.href = targetUrl
    })
  }
  // doubleTwelveVipToast()

  // 支付宝小程序适配
  initAliMp()
  function initAliMp() {
    if (!isAliMp) {
      return
    }
    // 隐藏客服按钮
    // document.getElementById('service-btn').style.display = 'none'
    // 隐藏想测按钮
    // e('.art-handler .vertical-bar').style.display = 'none'
    // e('##like-btn').style.display = 'none'
  }

  // 重置悬浮客服按钮
  function resetFloatServiceEvent () {
    let btnHtml = `
      <div id="float-service-btn">
        <div class="float-icon"></div>
      </div>`
    e('#app').insertAdjacentHTML('beforeend', btnHtml)
    let btn = e('#float-service-btn')
    btn.addEventListener('click', (event) => {
      let self = event.target.closest('#float-service-btn')
      if (!self) {
        return
      }
      let tipText = e('.service-tips-wrap')
      if (tipText) {
        tipText.remove()
      }
      let dialogHtml = `
      <div class="float-service-dialog">
        <div class="mask"></div>
        <div class="dialogWin" >
          <i class="close fs-18" >×</i>
          <div class="fs-16 content noTitle">
            <div>答题或查看报告过程有疑问，请添加客服微信，解决您的问题。</div>
          </div>
          <div class="service-qrcode" slot="content">
            <img class="qrcode" src="https://imgco.xinli001.com/ceping/resources/images/trinyMCE/e0355eed391b468bbafe565cb6223375.jpg"/>
          </div>
          <div class="action">
            <div class="btnCont" >
              <div class="btn fs-16 btn--yellow">好的</div>
            </div>
          </div>
        </div>
      </div>
      `
      e('#app').insertAdjacentHTML('beforeend', dialogHtml)

      appTrackEvent('app_cepingdetail_clickkefu', {
        test_id: scalePoolId,
        test_name: scaleName
      })

      function removeServiceDialogBox() {
        e('.float-service-dialog').remove()
      }

      e('.float-service-dialog .close').addEventListener('click', () => {
        removeServiceDialogBox()
      })
      e('.float-service-dialog .btnCont').addEventListener('click', () => {
        removeServiceDialogBox()
      })
    })
  }

  function toUserCenter () {
    let url = '';
    if (requiredParams.userKey || requiredParams.userId) {
      // 有登陆参数，去测试管理页面
      let params = {
        userKey: requiredParams.userKey,
        isCp: 1,
      }
      if (!isAPP) {
        params['userId'] = requiredParams.userId
        params['openId'] = requiredParams.openId
        params['channelId'] = requiredParams.channelId
      }
      url = `https://ce${APIS.env}.xinli001.com/cp-m/index.html#/manage/0?${objToUrlParams(params)}`
    } else {
      // 没有登录参数，直接打开登录页
      // 安卓openwebView会对URL进行一次decode，所以为了保持url的参数去到openWebView窗口仍然是encode状态，所以要进行2次encode
      let redirectBackUrl = encodeURIComponent(encodeURIComponent(location.href));

      url = `https://m${APIS.env}.xinli001.com/account/login-for-ceping?callbackUrl=${redirectBackUrl}&referer=${redirectBackUrl}`;
      console.log('redirectBackUrl', redirectBackUrl);
    }
    console.log('=== toUserCenter === url:', url)
    jumpMethods.openUrl(url);
  }

  // 初始化APP渠道的底部按钮DOM
  function initNewFooterBtn () {
    // let footerHomeDom = `
    //   <div class="s-tabcell footer-home">
    //     <div class="home-icon"></div>
    //   </div>`
    // let footerUserDom = `
    //   <div class="s-tabcell footer-user">
    //     <div class="user-icon"></div>
    //   </div>`

    // e('#service-btn').insertAdjacentHTML('beforebegin', footerHomeDom)
    // e('#service-btn').insertAdjacentHTML('afterend', footerUserDom)

    e('.footer-home').addEventListener('click', () => {
      appTrackEvent('app_cepingdetail_clickcphome', {
        test_id: scalePoolId,
        test_name: scaleName
      })
      location.href = 'yixinli://open_test_home'
    })

    e('.footer-user').addEventListener('click', () => {
      appTrackEvent('app_cepingdetail_clickmytest', {
        test_id: scalePoolId,
        test_name: scaleName
      })
      toUserCenter()
    })
  }

  // 初始化优惠券提示DOM
  function initFooterTips () {
    let footerHomeDom = `
    <div class="detail-footer-tips">
      <div class="footer-tips-close"></div>
      <div class="detail-footer-text">你有优惠券待使用 最低0元</div>
    </div>`
    e('.art-handler').insertAdjacentHTML('beforeend', footerHomeDom)

    function removeTips() {
      e('.detail-footer-tips').remove()
    }
    e('.detail-footer-tips .footer-tips-close').addEventListener('click', () => {
      removeTips()
    })
  }

  // 查询是否有优惠券
  function requestHasCoupon() {
    let url = '/coupon/getScalePoolCouponList'
    let { channelId } = requiredParams
    let category = e('#res-category').dataset.category
    let params = {
      channelId: channelId,
      category: category,
      scalePoolId: scalePoolId
    }
    // Stream.ajax(`/api${url}`, params).addListener({
    //   next(json) {
    //     let data = json.data ? json.data : []
    //     let isVip = e('#vipFLog') // 如果存在这个dom，则是在使用的VIP
    //     if (data.length && !isVip) {
    //       e('.detail-footer-tips').style.display = 'block';
    //       appTrackEvent('app_cepingdetail_youhuitips_show', {
    //         test_id: scalePoolId,
    //         test_name: scaleName
    //       })
    //     }
    //   }
    // })
    axios.get(`${APIS.cpapiHost}coupon/getScalePoolCouponList`, {
      params: params
    }).then(res => {
      let {code, data, msg} = res.data
      if (code == '1') {
        // let data = json.data ? json.data : []
        data = data || []
        let isVip = e('#vipFLog') // 如果存在这个dom，则是在使用的VIP
        if (data.length && !isVip) {
          e('.detail-footer-tips').style.display = 'block';
          appTrackEvent('app_cepingdetail_youhuitips_show', {
            test_id: scalePoolId,
            test_name: scaleName
          })
        }
      }
    })
  }

  // 测评下单是否是打包倾诉
  function initPackQingSu() {
    return new Promise(resolve => {
      axios.get(APIS.getConfigureByCode, {
        params: {
          configureCode: 'cp-miniProgram-pack-Qs'
        }
      }).then(res => {
        let config = JSON.parse(res.data.data.content)
        let channelId = Number(requiredParams.channelId)
        isPackQingSu = config[channelId] && config[channelId].isPackQs && !config[channelId].specialScalePoolIds.includes(Number(scalePoolId))
        // console.log('=== isPackQingSu ===', isPackQingSu)

        // if (isPackQingSu) {
        //   // 打包倾诉要隐藏价格
        //   let price = e('.art-price')
        //   price.style.display = 'none'
        // }
      })
    })
  }

  // 获取详情页面数据，暂时是美团小程序需要用到
  function initDetailData() {
    axios.get(APIS.getScaleDetailIntro, {
      params: {
        userKey: userKey,
        channelId: channelId,
        scalePoolId: scalePoolId,
      }
    }).then(res => {
      let {code, data, msg } = res.data
      if (code === "1") {
        scalePrice = data.discountPrice
        // scalePrice = 0
        // console.log('=== getScaleDetailIntro === scalePrice', scalePrice, typeof scalePrice)
      }
    })
  }

  if (isMeiTuanMp) {
    initPackQingSu()
    initDetailData()
    window.addEventListener(
      'pageshow',
      function(e) {
        if (e.persisted) {
          window.location.reload()
        }
      }
    )
  }

  if (isAPP) {
    // 隐藏原有的客服和想测按钮
    // document.getElementById('service-btn').style.display = 'none';
    // document.getElementById('like-btn').style.display = 'none';
    // 隐藏vip图标
    // if (e('.art-handler .buy-vip .icon-vip')) {
    //   e('.art-handler .buy-vip .icon-vip').style.display = 'none';
    // }

    resetFloatServiceEvent()
    initNewFooterBtn()
    initFooterTips()
    requestHasCoupon()
  }
}
window.userleft = false
window.onload = detailPage;



// WEBPACK FOOTER //
// ./src/entry/detail/index.js